import { atom } from "recoil";
export const dataAtLoginState = atom({
    key: "dataAtLoginState", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
